
export enum JoinStep {
  INITIAL = "initial",
  CREATE_PASSWORD = "create_password",
  PROFILE_INFO = "profile_info"
}

export interface InvitationData {
  id: string;
  email: string;
  company_id: string;
  status: string;
  token?: string;
  isSuperuserInvitation?: boolean;
}

export interface CompanyData {
  id: string;
  name: string;
}

export interface AuthVerificationResult {
  user: any;
  session: any;
}
